import { isEmpty } from 'lodash-es';

// We check whether data is empty as well because of a bug in Apollo:
// https://github.com/apollographql/react-apollo/issues/1314
const isLoading = (queryObj: { loading: boolean; data: unknown | undefined }) =>
  queryObj.loading || isEmpty(queryObj.data);

interface MaybeLoading<T, U> {
  loading: boolean;
  data: T | undefined;
  previousData?: T | undefined;
  variables?: U | undefined;
}
interface NotLoading<T, U> {
  loading: false;
  data: T;
  previousData?: T | undefined;
  variables: U;
}

export const isDoneLoading = <T, U>(queryObj: MaybeLoading<T, U>): queryObj is NotLoading<T, U> =>
  !isLoading(queryObj);
